import request from '@/utils/request';

export function fetchStats(query) {
  return request({
    url: 'https://viaglobal.pl/api//stats',
    method: 'get',
    params: query,
  });
}

export function fetchListRecruiters(query) {
  return request({
    url: 'https://viaglobal.pl/api//stats/recruiters',
    method: 'get',
    params: query,
  });
}

export function fetchRatingRecruitersByNumberOfPeople(query) {
  return request({
    url: 'https://viaglobal.pl/api//stats/fetchRatingRecruitersByNumberOfPeople',
    method: 'get',
    params: query,
  });
}
